import React from 'react'

function About() {
    return (
      <section className="bg-gray-100 py-12">
        <div className="container mx-auto">
          <h2 className="text-3xl font-bold mb-4">About Me</h2>
          <p className="text-lg text-gray-700">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus faucibus vehicula tellus in malesuada.
            In hac habitasse platea dictumst. Donec pharetra, dui nec iaculis gravida, eros nulla ultricies tortor,
            nec rutrum nisi enim a massa.
          </p>
        </div>
      </section>
    );
  }
export default About  